import LazyBuffer from "./lazy_buffer";
import StatisticsUtilities from "../utilities/statistics_utilities";


export default class MedianLazyBuffer extends LazyBuffer {
  reducer(values) {
    return StatisticsUtilities.sort_and_get_median(values);
  }
}
